{
  "mapTitle": "Mapa ng evacuation at kaligtasan",
  "mapLead": "Mga bukas na evacuation site na malapit sa iyo, mga mapanganib na lugar at saradong kalsada.",
  "mapLabel": "Mapa ng mga evacuation site, mapanganib na lugar at saradong kalsada",
  "whereAmI": "Nasaan ako?",
  "nearestTitle": "Pinakamalapit na bukas na site",
  "nearestFrom": "Tuwid na layo mula sa iyong lokasyon.",
  "nearestFromBarangay": "Unang nakalista ang mga bukas na site sa {barangay}.",
  "nearestFromTap": "Layo mula sa lugar na in-tap mo sa mapa.",
  "pickBarangayHint": "Naka-off ang lokasyon. Piliin ang iyong barangay, o i-tap ang mapa kung nasaan ka.",
  "noOpenSites": "Walang bukas na evacuation site ngayon. Sundin ang opisyal na abiso, at sa emergency tumawag sa 911.",
  "directions": "Kumuha ng direksyon",
  "directionsNote": "Bubuksan ang Google Maps; hindi nito alam ang mga saradong kalsada o panganib. Sundin ang opisyal na tagubilin.",
  "distanceAway": "{distance} ang layo",
  "allSites": "Lahat ng evacuation site",
  "emptySites": "Wala pang nailathalang evacuation site. Sa emergency, tumawag sa 911.",
  "status_open": "Bukas",
  "status_full": "Puno",
  "status_closed": "Sarado",
  "occupancy": "{occupancy} sa {capacity} katao",
  "occupancyNoCapacity": "{occupancy} katao",
  "facilities": "Mga pasilidad",
  "contact": "Kontak",
  "layers": "Mga layer ng mapa",
  "layerSites": "Mga evacuation site",
  "layerHazards": "Mga mapanganib na lugar",
  "layerClosures": "Mga saradong kalsada",
  "layerReports": "Mga aktibong ulat ng emergency (kawani lang)",
  "legend": "Alamat",
  "sourceDated": "Pinagmulan: {source}, {date}",
  "source": "Pinagmulan: {source}",
  "hazard_landslide": "Pagguho ng lupa",
  "hazard_flood": "Baha",
  "hazard_other": "Ibang panganib",
  "closureUntil": "Sarado hanggang {date}",
  "youAreHere": "Narito ka",
  "accuracy": "Tumpak sa humigit-kumulang {meters} m",
  "liveNote": "Live na nag-a-update ang dami ng tao at katayuan.",
  "showOnMap": "Ipakita sa mapa",
  "siteMarker": "{name}, {status}",
  "theLgu": "ang LGU",
  "offlineTitle": "Mapa para sa offline",
  "offlineHelp": "Itinatago ang mapa ng bayan sa iyong telepono para gumana kahit walang signal, halimbawa tuwing bagyo. Gumamit ng Wi-Fi kung kaya.",
  "offlineSave": "I-save ang mapa para sa offline",
  "offlineSize": "humigit-kumulang {size}",
  "offlineSaving": "Sine-save ang mapa… {percent}",
  "offlineSavedOn": "Na-save sa teleponong ito noong {date} ({size}).",
  "offlineDelete": "Alisin ang offline na mapa",
  "offlineUpdate": "I-update",
  "offlineError": "Hindi na-save ang mapa: {error}",
  "offlineSuggest": "Naka-on ang emergency mode. I-save na ang mapa para gumana kahit walang signal.",
  "offlineDone": "Na-save ang mapa para sa offline.",
  "offlineRemoved": "Naalis ang offline na mapa.",
  "hotlinesTitle": "Mga emergency hotline",
  "hotlinesLead": "Tumawag muna sa 911 para sa pulis, sunog at medikal na emergency.",
  "call911Body": "Pulis, sunog at medikal na emergency. Ang pagtawag ang pinakamabilis na paraan para makakuha ng tulong.",
  "localHotlines": "Mga lokal na hotline",
  "emptyHotlines": "Wala pang nailathalang lokal na hotline. Sa emergency, tumawag sa 911.",
  "callNumber": "Tawagan ang {number}",
  "emergencyModeTitle": "Naka-on ang emergency mode",
  "emergencyModeSince": "Mula {date}",
  "findNearest": "Hanapin ang pinakamalapit na bukas na evacuation site",
  "openMap": "Buksan ang mapa ng evacuation",
  "seeAllHotlines": "Lahat ng hotline",
  "adminTitle": "Mapa ng kaligtasan",
  "adminLead": "Mga evacuation site, mapanganib na lugar at saradong kalsada na nakikita ng mga residente.",
  "tabSites": "Mga evacuation site",
  "tabLayers": "Mga layer ng mapa",
  "addSite": "Magdagdag ng evacuation site",
  "editSite": "I-edit ang evacuation site",
  "siteName": "Pangalan ng site",
  "siteLocation": "Lokasyon sa mapa",
  "siteLocationHint": "I-drag ang pin o i-tap ang mapa sa pasukan ng site.",
  "pinRequired": "Ilagay ang pin sa mapa.",
  "capacity": "Kapasidad (katao)",
  "currentOccupancy": "Dami ng tao ngayon",
  "facilitiesHint": "Mag-tap ng mungkahi o mag-type ng sarili.",
  "addFacility": "Idagdag",
  "facilityName": "Ibang pasilidad",
  "removeFacility": "Alisin ang {name}",
  "contactName": "Contact person",
  "contactPhone": "Numero ng kontak",
  "notes": "Mga tala para sa residente",
  "published": "Ipakita sa mga residente",
  "publishedHint": "Ang hindi nailathalang site ay makikita lang ng kawani.",
  "unpublished": "Hindi ipinapakita sa residente",
  "deleteSite": "Burahin ang site",
  "confirmDeleteSite": "Burahin ang {name}? Hindi na ito maibabalik.",
  "siteSaved": "Na-save ang site.",
  "siteDeleted": "Nabura ang site.",
  "addPerson": "Magdagdag ng isang tao sa {name}",
  "removePerson": "Magbawas ng isang tao sa {name}",
  "addTen": "Magdagdag ng sampung tao sa {name}",
  "occupancyLabel": "Dami ng tao sa {name}",
  "statusOf": "Katayuan ng {name}",
  "autoFull": "Awtomatikong minamarkahang puno kapag naabot ang kapasidad.",
  "addHazard": "Magdagdag ng hazard layer",
  "addClosure": "Magdagdag ng saradong kalsada",
  "editLayer": "I-edit ang layer",
  "layerTitle": "Pamagat",
  "hazardType": "Uri ng panganib",
  "sourceName": "Pinagmulan",
  "sourceNameHint": "Saan galing ang datos, ayon sa kumpirmasyon ng MDRRMO, hal. PHIVOLCS GeoRiskPH o Project NOAH.",
  "sourceDate": "Petsa ng pinagmulan",
  "sourceDateRequired": "Ilagay ang petsa ng datos.",
  "geojsonFile": "GeoJSON file",
  "geojsonHint": "Isang .geojson file na may mga polygon, hanggang 10 MB.",
  "geojsonKeep": "Iwanang blangko para panatilihin ang kasalukuyang hugis.",
  "geojsonRequired": "Pumili ng GeoJSON file.",
  "geojsonInvalid": "Hindi wastong GeoJSON ang file na ito: {error}",
  "geojsonTooBig": "Mas malaki sa 10 MB ang file. Pasimplehin ang mga hugis at subukang muli.",
  "featuresLoaded": "{count} hugis ang na-load.",
  "preview": "Silipin",
  "closureDraw": "I-tap ang mapa sa kahabaan ng saradong kalsada para iguhit ito.",
  "closurePoints": "{count} punto",
  "undoPoint": "I-undo ang huling punto",
  "clearPoints": "I-clear",
  "closureNeedsLine": "Mag-tap ng hindi bababa sa dalawang punto sa mapa.",
  "validFrom": "Sarado mula",
  "validUntil": "Sarado hanggang",
  "validHint": "Iwanang blangko kung hindi alam. Nawawala sa pampublikong mapa ang pagsasara pagkalipas ng oras ng pagtatapos.",
  "visibleToggle": "Nakikita ng mga residente",
  "hidden": "Nakatago",
  "shapes": "{count} hugis",
  "deleteLayer": "Burahin ang layer",
  "confirmDeleteLayer": "Burahin ang {name}?",
  "emptyLayers": "Wala pang mapanganib na lugar o saradong kalsada.",
  "layerSaved": "Na-save ang layer.",
  "layerDeleted": "Nabura ang layer.",
  "fallbackMissing": "Hindi pa naka-set up ang backup na mapa (MAP_FALLBACK_PMTILES_URL), kaya hindi gagana ang mapa ng residente nang offline o kapag down ang OpenFreeMap. Hilingin sa IT na patakbuhin ang npm run map:extract.",
  "emTitle": "Emergency mode",
  "emLead": "Sa panahon ng sakuna, nagpapakita ang emergency mode ng pulang banner sa bawat residente at inilalagay sa itaas ng home screen ang mga abiso, hotline at panghanap ng pinakamalapit na site.",
  "emIsOn": "NAKA-ON ang emergency mode",
  "emIsOff": "Naka-off ang emergency mode",
  "emMessage": "Mensahe sa mga residente",
  "emMessageHint": "Maikli at malinaw, hal. \"Typhoon Signal No. 3. Bukas ang mga evacuation site. Iwasan ang mga kalsadang madalas gumuho.\"",
  "emTurnOn": "I-on ang emergency mode",
  "emTurnOff": "I-off ang emergency mode",
  "emUpdateMessage": "I-update ang mensahe",
  "emConfirmOnTitle": "I-on ang emergency mode?",
  "emConfirmOnBody": "Makikita agad ng bawat residente ang pulang emergency banner.",
  "emConfirmOffTitle": "I-off ang emergency mode?",
  "emConfirmOffBody": "Mawawala ang emergency banner para sa lahat.",
  "emStartedAt": "Na-on noong {date}",
  "emDone": "Na-update ang emergency mode.",
  "confirm": "Kumpirmahin",
  "hotAdminTitle": "Mga hotline",
  "hotAdminLead": "Mga lokal na numero ng emergency at opisina. Laging nauuna ang 911 at hindi ito maaalis.",
  "addHotline": "Magdagdag ng hotline",
  "editHotline": "I-edit ang hotline",
  "hotName": "Pangalan",
  "hotAgency": "Ahensya o opisina",
  "hotNumbers": "Mga numero ng telepono",
  "hotNumber": "Numero {n}",
  "addNumber": "Magdagdag ng isa pang numero",
  "removeNumber": "Alisin ang numero {n}",
  "hotNote": "Tala",
  "hotPublished": "Ipakita sa mga residente",
  "moveUp": "Itaas ang {name}",
  "moveDown": "Ibaba ang {name}",
  "confirmDeleteHotline": "Burahin ang {name}?",
  "hotlineSaved": "Na-save ang hotline.",
  "hotlineDeleted": "Nabura ang hotline.",
  "builtIn911": "911 · laging una",
  "emptyHotlinesAdmin": "Wala pang lokal na hotline. Idagdag ang mga numero ng MDRRMO, pulis, bumbero at kalusugan na kinumpirma ng bawat opisina."
}
